import { CSSProperties, ReactNode } from 'react'
import cx from 'classnames'
import './styles.scss'

interface QuestionProps {
  title: ReactNode
  hint?: ReactNode
  children?: ReactNode
  addOn?: ReactNode
  style?: CSSProperties
  className?: string
  size?: 'large' | 'middle'
}

export function Question({ title, hint, addOn, children, className, size = 'large', style, ...rest }: QuestionProps) {
  return (
    <div className={cx('app-question', className)} style={style} {...rest}>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex -- Useful to interact with */}
      <div className="u -margin-bottom--small" tabIndex={0}>
        <div
          className={cx('app-question-title', {
            'u-font-16': size === 'large',
            'u-margin-bottom--tiny': hint,
            'u-flex-space-between': addOn
          })}
        >
          <div>{title}</div>
          {addOn ? <div className="u-margin-left--medium">{addOn}</div> : null}
        </div>
        {hint ? (
          <div id="question-hint" className="app-question-hint">
            {hint}
          </div>
        ) : null}
      </div>
      {children}
    </div>
  )
}

export default Question
